import { Rpc } from "../rpc";
import { ValueWrapper } from "../ValueWrapper";

export class TeamManagementRpc {

    public static getData(): Promise<TeamDataResponse> {
        return Rpc.GET("/rpc/settings/team/data");
    }

    public static createTeam(name: string): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/settings/team/createTeam", { name: name });
    }

    public static deleteTeam(teamId: number): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/settings/team/deleteTeam", { value: teamId });
    }

    public static inviteUser(req: InviteUserRequest): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/settings/team/inviteUser", req);
    }

    public static resendInvitation(invitationId: string): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/settings/team/resendInvitation", { value: invitationId });
    }

    public static revokeInvitation(invitationId: string): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/settings/team/revokeInvitation", { value: invitationId });
    }

    public static editUser(req: EditUserRequest): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/settings/team/editUser", req);
    }

    public static deleteUser(userId: number): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/settings/team/deleteUser", { value: userId });
    }

    public static changeVacationCount(req: ChangeVacationCountRequest): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/settings/team/changeVacationCount", req);
    }

    private constructor() {}

}

export interface TeamDataResponse {

    readonly teams: TeamManagementTeamItem[];
    readonly users: TeamManagementUserItem[];

}

export interface TeamManagementTeamItem {

    readonly id: number;
    readonly name: string;
    readonly userCount: number;

}

export interface TeamManagementUserItem {

    readonly id: string;
    readonly name: string;
    readonly email: string;
    readonly roleName: string;
    readonly roleTitle: string;
    readonly teamId?: number;
    readonly teamName?: string;
    readonly pendingInvitation: boolean;

}

export interface InviteUserRequest {

    name: string;
    email: string;
    role: string;
    teamId: string;
    yearlyVacations: string;
    rolledVacations: string;
    usedUpVacations: string;

}

export interface EditUserRequest {

    userId: number;
    name: string;
    role: string;
    teamId: string;

}

export interface ChangeVacationCountRequest {

    userId: number;
    yearlyVacationCount: string;
    rolledVacationCount: string;

}
